import Reflux from 'reflux';
import UserData from 'shared/data/User';

let async = { asyncResult: true },
  CuesheetCueClockActions = Reflux.createActions({
    populate: {},
    playCueClockWithDuration: {},
    updateCueClockPersistent: async,
    toggleFullScreenClock: {},
    //sets actualDurationInSeconds and has the option to override the
    //durationInSeconds value with the actual duration
    updateItemDurationsToCurrentDuration: {},
    clearClock: {}, //Used when changing shows, essentially to stop interval
  });

CuesheetCueClockActions.updateCueClockPersistent.listenAndPromise(
  UserData.updateTrackableCueClock,
);

export default CuesheetCueClockActions;
